export default "__VITE_ASSET__BSdTU2is__"